export class CompanyConstant {
    static COM_ID_MEDIUSKR: string = 'ACEONEKR';
    static COM_ID_MEDIUS: string = 'ACEONEUS';
    // static COM_ID_MEDIUSUS: string = 'MEDIUSUS';
  }